import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { TenorValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryTenorFieldProps {
  node: TenorValueDefinition;
}

export const ProductSummaryTenorField: FC<ProductSummaryTenorFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        {data?.currentValue.value}{' '}
        <FormattedMessage id={`form.${translationKey}.${data?.currentValue.unit}` as IntlKey} />
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryTenorField.displayName = 'ProductSummaryTenorField';
